// Get Licences
export const getLicences = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('/licenses')
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
};

// Get Licence
export const getLicence = ({ commit, dispatch, state }, licenceId) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/licenses/${licenceId}`)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
};

// Make License Request
export const makeLicenseRequest = ({ commit, dispatch, state }, requestData) => {
  return new Promise((resolve, reject) => {
    window.axios.post('/licenses/request', requestData)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
};

// Get User Licenses
export const getUserLicenses = ({ commit, dispatch, state }, userId) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/users/${userId}/licenses`)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
};

// Get Users with License
export const getUsersWithLicense = ({ commit, dispatch, state }, licenceId) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/licenses/${licenceId}/users`)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
};

// Use License
export const useLicense = ({ commit, dispatch, state }, requestData) => {
  return new Promise((resolve, reject) => {
    window.axios.post('/licenses/use', requestData)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
};

// Check Valid License
export const hasValidLicense = ({ commit, dispatch, state }, requestData) => {
  return new Promise((resolve, reject) => {
    window.axios.post('/licenses/valid', requestData)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
};
